import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";

export const GetOtpRecordsBIZnotifications = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getOtpRecordsBIZnotifications(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_OTP_RECORDS_BIZ_NOTIFICATIONS, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
